import { NgModule } from '@angular/core';
import { BaseSharedModule } from 'base';
import { BaseCustomerOnboardingService } from './_services/onboarding.service';
import { BaseCustomerOnboardingLightComponent } from './_components/onboarding-light/onboarding-light.component';
import { BaseCustomerOnboardingLightBannerComponent } from './_components/onboarding-light-banner/onboarding-light-banner.component';

@NgModule({
  declarations: [BaseCustomerOnboardingLightComponent, BaseCustomerOnboardingLightBannerComponent],
  imports: [BaseSharedModule],
  providers: [BaseCustomerOnboardingService],
  exports: [BaseCustomerOnboardingLightComponent, BaseCustomerOnboardingLightBannerComponent],
})
export class BaseCustomerOnboardingModule {}
